import { useEffect } from "react";
import { useRegUIClient } from "@foundation/reg-ui-client";

import { updateUserInfo } from "~redux/features/user-slice";
import useRedux from "~redux/hooks";

export const useUserData = () => {
    const { useAppDispatch } = useRedux();
    const dispatch = useAppDispatch();
    const { session } = useRegUIClient();

    useEffect(() => {
        dispatch(updateUserInfo(session?.userInfo));
    }, [session?.userInfo]);
};
